import { TApplicationState } from '../../types/redux';

export const selectIsFormValid = (state: TApplicationState) => {
  return state.submitForm.isFormValid;
};
